// Vuex persistence using SQLite via storageAdapter
import { getValue, setValue, getStorage } from './storageAdapter';

const VUEX_STORE_TABLE = 'sessions'; // Using sessions table for Vuex state
const FALLBACK_PREFIX = 'vuex_fallback_';

const getFallbackKey = (key) => `${FALLBACK_PREFIX}${key}`;

export const idbTransactionalStorage = {
    async getItem(key) {
        try {
            const value = await getValue(key, VUEX_STORE_TABLE);
            if (value !== undefined && value !== null) return value;
            return localStorage.getItem(getFallbackKey(key)) || undefined;
        } catch (error) {
            console.error('[idbStorage] Error getting item:', error);
            return localStorage.getItem(getFallbackKey(key)) || undefined;
        }
    },
    async setItem(key, value) {
        try {
            await setValue(key, value, VUEX_STORE_TABLE);
        } catch (error) {
            console.error('[idbStorage] Error setting item:', error);
        } finally {
            try {
                localStorage.setItem(
                    getFallbackKey(key),
                    typeof value === 'string' ? value : JSON.stringify(value)
                );
            } catch (_) {}
        }
    },
    async removeItem(key) {
        try {
            const storage = await getStorage();
            await storage.run(
                `DELETE FROM ${VUEX_STORE_TABLE} WHERE key = ?`,
                [key]
            );
        } catch (error) {
            console.error('[idbStorage] Error removing item:', error);
        } finally {
            try { localStorage.removeItem(getFallbackKey(key)); } catch (_) {}
        }
    },

};

function cleanUpState(state) {
    return JSON.parse(JSON.stringify(state));
}

export const saveState = async (key, value) => {
    const cleanState = cleanUpState(value);
    const payload = JSON.stringify(cleanState);
    try {
        await setValue(key, payload, VUEX_STORE_TABLE);
    } catch (err) {
        console.error('[VuexPersist] Error saving state:', err);
    } finally {
        try {
            localStorage.setItem(getFallbackKey(key), payload);
        } catch (_) {}
    }
};

export const restoreState = async (key) => {
    try {
        let storedValue = await getValue(key, VUEX_STORE_TABLE);
        if (storedValue === undefined || storedValue === null || storedValue === '') {
            storedValue = localStorage.getItem(getFallbackKey(key));
        }

        if (storedValue) {
            const value = typeof storedValue === 'string' ? JSON.parse(storedValue) : storedValue;

            // Check if there are currentSaleLines in localStorage
            const storedSaleLines = localStorage.getItem('currentSaleLines');
            if (storedSaleLines) {
                try {
                    const parsedSaleLines = JSON.parse(storedSaleLines);
                    if (Array.isArray(parsedSaleLines) && parsedSaleLines.length > 0) {
                        // If salesModule exists in the state, update its currentSaleLines
                        if (value.salesModule) {
                            value.salesModule.currentSaleLines = parsedSaleLines;
                        }
                    }
                } catch (error) {
                    console.error('Error parsing stored sale lines:', error);
                }
            }

            value.loading = false;
            value.isHydrated = true;
            return value;
        }
        return { isHydrated: true };
    } catch (err) {
        console.error('[VuexPersist] Error restoring state:', err);
        try {
            const fallback = localStorage.getItem(getFallbackKey(key));
            if (fallback) {
                const value = JSON.parse(fallback);
                value.loading = false;
                value.isHydrated = true;
                return value;
            }
        } catch (_) {}
        return { isHydrated: true };
    }
};
